import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule, HttpClientJsonpModule } from "@angular/common/http";
import {
  SocialLoginModule,
  AuthServiceConfig,
  FacebookLoginProvider,
  GoogleLoginProvider,
} from "angularx-social-login";

import { AngularFireModule } from "@angular/fire";
import { AngularFireStorageModule } from "@angular/fire/storage";

import { NgCircleProgressModule } from "ng-circle-progress";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
/* import {LeafletModule} from '@asymmetrik/ngx-leaflet';*/

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ToastComponent } from "./components/toast/toast.component";
import { HomeComponent } from "./pages/home/home.component";
import { HeaderComponent } from "./components/header/header.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FooterComponent } from "./components/footer/footer.component";
import { YtvidComponent } from "./components/ytvid/ytvid.component";

import { ModalModule } from "ngx-bootstrap";
import { LoginComponent } from "./components/modals/login/login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CatalogComponent } from "./pages/catalog/catalog.component";
import { ArticleComponent } from "./components/article/article.component";
import { FeaturesComponent } from "./components/features/features.component";
import { ProductComponent } from "./pages/product/product.component";
import { DurableIconComponent } from "./pages/product/durable-icon/durable-icon.component";
import { ProductOptionsComponent } from "./pages/product/product-options/product-options.component";
import { MatteIconComponent } from "./pages/product/matte-icon/matte-icon.component";
import { GlossyIconComponent } from "./pages/product/glossy-icon/glossy-icon.component";
import { ArtworkComponent } from "./components/modals/artwork/artwork.component";
import { ContactComponent } from "./pages/contact/contact.component";
import { AgmCoreModule, MapsAPILoader } from "@agm/core";
import { CartComponent } from "./pages/cart/cart.component";
import { ConfirmationComponent } from "./pages/orders/confirmation/confirmation.component";
import { OrdersComponent } from "./pages/orders/orders/orders.component";
import { PageNotfoundComponent } from "./pages/page-notfound/page-notfound.component";
import { SummaryComponent } from "./pages/orders/summary/summary.component";
import { ReviewartworkComponent } from "./pages/orders/reviewartwork/reviewartwork.component";
import { PluralPipe } from "./lib/pipes/plural.pipe";
import { ApproveartworkComponent } from "./components/modals/approveartwork/approveartwork.component";
import { CancelartworkComponent } from "./components/modals/cancelartwork/cancelartwork.component";
import { MessagingComponent } from "./components/messaging/messaging.component";
import { MessageComponent } from "./components/modals/message/message.component";
import { QuickorderComponent } from "./pages/quickorder/quickorder.component";
import { CartEmptyStateComponent } from "./pages/cart/cart-empty-state/cart-empty-state.component";
import { UsesComponent } from "./pages/uses/uses.component";
import { CmspagesComponent } from "./pages/cmspages/cmspages.component";
import { CheckoutComponent } from "./pages/checkout/checkout.component";
import { MoneyPipe } from "./lib/pipes/money.pipe";

import { FooterCheckoutComponent } from "./components/footer/footer-checkout/footer-checkout.component";
import { PaymentComponent } from "./components/modals/payment/payment.component";
import { GuidelinesComponent } from "./components/modals/guidelines/guidelines.component";
import { ConfirmationmodalComponent } from "./components/modals/confirmationmodal/confirmationmodal.component";
import { AdminloginComponent } from "./pages/adminlogin/adminlogin.component";
import { InfoComponent } from "./components/modals/info/info.component";
import { ReviewsComponent } from "./pages/product/reviews/reviews.component";
import { ReviewformComponent } from "./components/modals/reviewform/reviewform.component";
import { CarouselModule } from "ngx-owl-carousel-o";
import { MapComponent } from "./pages/checkout/map/map.component";
import { AboutComponent } from "./pages/about/about.component";
import { MaintenancePageComponent } from "./pages/maintenance-page/maintenance-page.component";
import { DecimalPipe } from "@angular/common";
import { CustomerBlockComponent } from './components/customer-block/customer-block.component';
import { PageBlockCommonComponent } from './components/page-block-common/page-block-common.component';
import { TransparentStickerComponent } from './pages/product/transparent-sticker/transparent-sticker.component';
import { ProductIconComponent } from './pages/product/product-icon/product-icon.component';
import { environment } from 'src/environments/environment';
import { PaymentGenericComponent } from './pages/payment-generic/payment-generic.component';
import { CuttingTypeComponent } from './components/modals/product/options/cutting-type/cutting-type.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { AddressBookComponent } from './pages/address-book/address-book.component';
import { AddressesAndFormFieldComponent } from './components/addresses-and-form-field/addresses-and-form-field.component';
import { DragonpayProcBecomeUnavailableComponent } from './components/modals/dragonpay-proc-become-unavailable/dragonpay-proc-become-unavailable.component';
import { ProductTShirtComponent } from './pages/product-t-shirt/product-t-shirt.component';
import { ProductTShirtOptionsComponent } from './pages/product-t-shirt/product-t-shirt-options/product-t-shirt-options.component';
import { TshirtArtworkComponent } from './components/modals/tshirt-artwork/tshirt-artwork.component';
import { TshirtPrintLimitationComponent } from './components/modals/tshirt-print-limitation/tshirt-print-limitation.component';
import { FreeShippingBannerTopComponent } from './components/free-shipping-banner-top/free-shipping-banner-top.component';
import { CustomCanvasToteBagOptionsComponent } from './pages/product-t-shirt/custom-canvas-tote-bag-options/custom-canvas-tote-bag-options.component';
import { TotebagArtworkComponent } from './components/modals/totebag-artwork/totebag-artwork.component';
import { FilesComponent } from './pages/files/files.component';
import { FilesizePipe } from './lib/pipes/filesize.pipe';
import { TzdatePipe } from './lib/pipes/tzdate.pipe';
import { FileManagerAddToCartComponent } from './components/modals/file-manager-add-to-cart/file-manager-add-to-cart.component';
import { ElectionTShirtComponent } from './pages/election-t-shirt/election-t-shirt.component';
import { WalletComponent } from './pages/wallet/wallet.component';
import { ChangeorderrequestComponent } from './components/modals/changeorderrequest/changeorderrequest.component';

let config = new AuthServiceConfig([
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider(environment.social_login.facebook_id),
  },
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(
		environment.social_login.google_id
    ),
  },
]);
export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    ToastComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    YtvidComponent,
    LoginComponent,
    CatalogComponent,
    ArticleComponent,
    FeaturesComponent,
    ProductComponent,
    DurableIconComponent,
    ProductOptionsComponent,
    MatteIconComponent,
    GlossyIconComponent,
    ArtworkComponent,
    ContactComponent,
    ConfirmationComponent,
    CartComponent,
    OrdersComponent,
    PageNotfoundComponent,
    SummaryComponent,
    ReviewartworkComponent,
    PluralPipe,
    ApproveartworkComponent,
    CancelartworkComponent,
    MessagingComponent,
    MessageComponent,
    QuickorderComponent,
    CartEmptyStateComponent,
    UsesComponent,
    CmspagesComponent,
    CheckoutComponent,
    MoneyPipe,
    FooterCheckoutComponent,
    PaymentComponent,
    GuidelinesComponent,
    ConfirmationmodalComponent,
    AdminloginComponent,
    InfoComponent,
    ReviewsComponent,
    ReviewformComponent,
    MapComponent,
    AboutComponent,
    MaintenancePageComponent,
    CustomerBlockComponent,
    PageBlockCommonComponent,
    TransparentStickerComponent,
    ProductIconComponent,
	PaymentGenericComponent,
	CuttingTypeComponent,
	SideNavComponent,
	AddressBookComponent,
	AddressesAndFormFieldComponent,
	DragonpayProcBecomeUnavailableComponent,
	ProductTShirtComponent,
	ProductTShirtOptionsComponent,
	TshirtArtworkComponent,
	TshirtPrintLimitationComponent,
	FreeShippingBannerTopComponent,
	CustomCanvasToteBagOptionsComponent,
	TotebagArtworkComponent,
	FilesComponent,
	FilesizePipe,
	TzdatePipe,
	FileManagerAddToCartComponent,
	ElectionTShirtComponent,
	WalletComponent,
	ChangeorderrequestComponent
  ],
  entryComponents: [
    LoginComponent,
    ArtworkComponent,
    ApproveartworkComponent,
    CancelartworkComponent,
    MessageComponent,
    PaymentComponent,
    GuidelinesComponent,
    ConfirmationmodalComponent,
    InfoComponent,
    ReviewformComponent,
  ],
  imports: [
    CarouselModule,
    BrowserModule,
    InfiniteScrollModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ModalModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HttpClientJsonpModule,
    SocialLoginModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAduafcSGDO4HjZ-1taw3m19N6EEef9L3w",
      libraries: ["places"],
    }),
    /* AngularFireModule.initializeApp({
      apiKey: "AIzaSyDANMTkWD0LhAoz6DG58IpN3jrTpZ70_tQ",
      authDomain: "test-484b9.firebaseapp.com",
      databaseURL: "https://test-484b9.firebaseio.com",
      projectId: "test-484b9",
      storageBucket: "test-484b9.appspot.com",
      messagingSenderId: "684474926998",
      appId: "1:684474926998:web:55ac299090cb81c7627fb7",
      measurementId: "G-LK3RRCNPQ6"
    }), */
    AngularFireModule.initializeApp({
      apiKey: "AIzaSyClWQLy5TeJrNJhx2sOtjU8ygsrsA3tVn0",
      authDomain: "entrelabel-1590398351267.firebaseapp.com",
      databaseURL: "https://entrelabel-1590398351267.firebaseio.com",
      projectId: "entrelabel-1590398351267",
      storageBucket: "entrelabel-1590398351267.appspot.com",
      messagingSenderId: "441971591905",
      appId: "1:441971591905:web:2e121c3bbaefac76f505a0",
      measurementId: "G-DTRCYZ15C7"
    }),
    AngularFireStorageModule,
    NgCircleProgressModule.forRoot({
      backgroundStrokeWidth: 0,
      backgroundPadding: 5,
      radius: 60,
      space: -17,
      outerStrokeWidth: 17,
      outerStrokeColor: "#4882c2",
      outerStrokeGradientStopColor: "#53a9ff",
      outerStrokeLinecap: "square",
      innerStrokeColor: "#e7e8ea",
      innerStrokeWidth: 17,
      animationDuration: 300,
      clockwise: true,
      startFromZero: false,
      showSubtitle: false,
      titleFontSize: "40",
      unitsFontSize: "40",
      titleFontWeight: "800",
      unitsFontWeight: "800",
      titleColor: "#090000",
      unitsColor: "#000000",
    }),
    /* LeafletModule */
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig,
    },
    DecimalPipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
